export default "__VITE_ASSET__pfmcSxjF__"